module.exports = __webpack_public_path__ + "img/switch-camera.a2c6055b.svg";